import React, { Component } from "react";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/es';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { connect } from "react-redux";
import * as aloharFormActions from "../../../store/aloharForm/actions";
import AxiosAuth from "../../../services/requestApi";
import { BASE_URL } from "../../../Helpers";
import { withRouter } from "react-router-dom";
import ProgressBar from "../Utils/ProgressBar";
import ButtonPrimary from "../../ui/button-primary";
import ErrorAlert from "../../Alerts/ErrorAlert";
import ConfirmModal from "../../Modals/ConfirmModal";
import ModalWrapper from "../../Modals/ModalWrapper";
import CalendarSincronize from "../../calendar-sincronize";
import TradCalendar from "../json/TradCalendar.json";
import Buttons from "../Utils/Buttons";  // ✅ AÑADIDO: Importar componente Buttons
import ButtonEdit from "../Utils/ButtonEdit";  // ✅ AÑADIDO: Importar ButtonEdit para modo edición
import "../../../assets/styles/AloharForm/Steps/_calendar-v2.sass";

// Configurar localización
moment.locale('es');
const localizer = momentLocalizer(moment);

// Configuración de tipos de disponibilidad
const AVAILABILITY_TYPES = {
  AVAILABLE: 'available',
  BLOCKED: 'blocked',
  HOT_SALE: 'hot_sale',
  RESERVATION: 'reservation'
};

const COLORS = {
  [AVAILABILITY_TYPES.AVAILABLE]: '#28a745',
  [AVAILABILITY_TYPES.BLOCKED]: '#dc3545', 
  [AVAILABILITY_TYPES.HOT_SALE]: '#fd7e14',
  [AVAILABILITY_TYPES.RESERVATION]: '#007bff'
};

class NewCalendar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Datos del calendario
      calendarEvents: this.processCalendarData(props.bodyParameters.calendar),
      selectedDates: [],
      currentDate: new Date(),
      
      // UI State
      showSidebar: false,
      selectedRange: null,
      
      // ✅ NUEVOS ESTADOS para selección mejorada:
      isSelecting: false,
      tempSelection: null,
      
      // Formulario
      availabilityType: AVAILABILITY_TYPES.AVAILABLE,
      price: props.bodyParameters.basePrice || 0,
      basePrice: props.bodyParameters.basePrice || 0,
      
      // Errores y modales
      error: null,
      showDeleteModal: false,
      eventToDelete: null,
      
      // Otros
      housingId: "",
      userRole: { role: "user" },
      lenguaje: props.lenguaje || "es",
      modeEdit: props.modeEdit || false
    };

    this.props.calendarStep({ calendar: props.bodyParameters.calendar });
  }

  // Procesar datos del calendario desde el servidor
  processCalendarData = (calendarData) => {
    console.log('🔍 Datos originales del servidor:', calendarData); // ✅ DEBUG
    
    return calendarData.map(item => {
      // ✅ CORREGIDO: Manejar fechas correctamente para react-big-calendar
      const startDate = moment(item.originalStart || item.start).startOf('day');
      
      // ✅ IMPORTANTE: Para react-big-calendar, end debe ser el día SIGUIENTE al último día inclusivo
      // Si el servidor dice "end": "2025-10-30", el calendario debe mostrar hasta el 30, 
      // pero react-big-calendar necesita "2025-10-31" (día siguiente)
      const serverEndDate = moment(item.originalEnd || item.end).startOf('day');
      const endDate = serverEndDate.clone().add(1, 'day'); // ✅ +1 día para react-big-calendar
      
      console.log(`📅 Procesando evento:`, {
        server: { 
          start: item.originalStart || item.start, 
          end: item.originalEnd || item.end 
        },
        calendar: { 
          start: startDate.format('YYYY-MM-DD'), 
          end: endDate.format('YYYY-MM-DD')
        },
        display: `Del ${startDate.format('DD/MM/YYYY')} al ${serverEndDate.format('DD/MM/YYYY')}`
      }); // ✅ DEBUG
      
      return {
        id: `${item.originalStart || item.start}-${item.originalEnd || item.end}`,
        title: this.getEventTitle(item),
        start: startDate.toDate(),
        end: endDate.toDate(), // ✅ Día siguiente para react-big-calendar
        price: item.amount || item.price || 0,
        type: this.mapTypeHousingCalendar(item.typeHousingCalendar),
        // ✅ CORREGIDO: Usar datos originales del servidor para operaciones de API y modal
        originalData: {
          ...item,
          start: item.originalStart || item.start,
          end: item.originalEnd || item.end
        },
        allDay: true,
        resource: {
          backgroundColor: this.getEventColor(item.typeHousingCalendar),
          textColor: '#ffffff'
        }
      };
    });
  };

  // Mapear tipos de calendario
  mapTypeHousingCalendar = (type) => {
    switch (type) {
      case 'block': return AVAILABILITY_TYPES.BLOCKED;
      case 'hot_sale': return AVAILABILITY_TYPES.HOT_SALE;
      case 'Hold': return AVAILABILITY_TYPES.RESERVATION;
      default: return AVAILABILITY_TYPES.AVAILABLE;
    }
  };

  // Obtener color del evento
  getEventColor = (type) => {
    const mappedType = this.mapTypeHousingCalendar(type);
    return COLORS[mappedType];
  };

  // Obtener título del evento
  getEventTitle = (item) => {
    switch (item.typeHousingCalendar) {
      case 'block': return 'Bloqueado';
      case 'hot_sale': return 'Hot Sale';
      case 'Hold': return 'Reserva';
      default: return item.amount ? `$${item.amount}` : 'Disponible';
    }
  };

  componentDidMount = async () => {
    const { id } = this.props.match.params;
    if (id) {
      this.setState({ housingId: id });
    }
    
    const userRole = JSON.parse(window.localStorage.getItem("role") || '{"role":"user"}');
    this.setState({ userRole });
    
    // ✅ AGREGAR listener global para mouseup
    document.addEventListener('mouseup', this.handleMouseUp);
  };

  componentWillUnmount = () => {
    // ✅ LIMPIAR listener
    document.removeEventListener('mouseup', this.handleMouseUp);
  };

  // ✅ NUEVAS FUNCIONES para manejo mejorado de selección:

  // Iniciar selección de rango
  handleMouseDown = (date) => {
    if (!this.state.showSidebar) return;
    
    this.setState({
      isSelecting: true,
      tempSelection: {
        start: date,
        end: date
      }
    });
  };

  // Actualizar selección mientras se arrastra
  handleMouseEnter = (date) => {
    if (!this.state.isSelecting || !this.state.tempSelection) return;
    
    const { tempSelection } = this.state;
    const start = moment(tempSelection.start).isBefore(moment(date)) 
      ? tempSelection.start 
      : date;
    const end = moment(tempSelection.start).isAfter(moment(date)) 
      ? tempSelection.start 
      : date;
      
    this.setState({
      tempSelection: { start, end },
      selectedRange: { start, end }
    });
  };

  // Finalizar selección
  handleMouseUp = () => {
    if (!this.state.isSelecting) return;
    
    this.setState({
      isSelecting: false,
      tempSelection: null
    });
  };

  // Manejar click en día (mejorado)
  handleDayClick = (date) => {
    if (!this.state.showSidebar) {
      // Si el sidebar no está abierto, comportamiento normal
      this.handleSelectSlot({ start: date, end: moment(date).toDate() });
    } else {
      // Si el sidebar está abierto, iniciar nueva selección
      this.setState({
        selectedRange: { start: date, end: date }
      });
    }
  };

  // Manejar selección de rango de fechas
  handleSelectSlot = ({ start, end, slots }) => {
    this.setState({
      selectedRange: { start, end, slots },
      showSidebar: true,
      price: this.state.basePrice,
      availabilityType: AVAILABILITY_TYPES.AVAILABLE
    });
  };

  // Manejar click en evento existente
  handleSelectEvent = (event) => {
    this.setState({
      eventToDelete: event,
      showDeleteModal: true
    });
  };

  // ✅ FUNCIÓN handleDateChange CORREGIDA:
  handleDateChange = (type, value) => {
    const { selectedRange } = this.state;
    if (!selectedRange) return;
    
    // ✅ CORREGIDO: Crear fecha sin problemas de timezone
    const dateParts = value.split('-');
    const year = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1; // Los meses en JS van de 0-11
    const day = parseInt(dateParts[2], 10);
    
    const newDate = new Date(year, month, day);
    
    const updatedRange = {
      ...selectedRange,
      [type]: newDate
    };
    
    // Validar que la fecha de inicio no sea mayor que la de fin
    if (type === 'start' && updatedRange.end < newDate) {
      updatedRange.end = newDate;
    } else if (type === 'end' && updatedRange.start > newDate) {
      updatedRange.start = newDate;
    }
    
    this.setState({
      selectedRange: updatedRange
    });
  };

  // Guardar nueva configuración de fechas
  handleSave = async () => {
    const { selectedRange, availabilityType, price } = this.state;
    
    if (!selectedRange) return;

    // Validar formulario
    if (availabilityType === AVAILABILITY_TYPES.AVAILABLE && !price) {
      this.setState({ error: "Debe especificar un precio para fechas disponibles" });
      return;
    }

    // ✅ CORREGIDO: Crear nuevo evento con el formato correcto para react-big-calendar
    const startDate = moment(selectedRange.start).startOf('day');
    const endDate = moment(selectedRange.end).startOf('day');
    
    // ✅ IMPORTANTE: Para react-big-calendar, el evento necesita end+1 día
    const calendarEndDate = endDate.clone().add(1, 'day');
    
    const newEvent = {
      id: `${startDate.format('YYYY-MM-DD')}-${endDate.format('YYYY-MM-DD')}`,
      title: this.generateEventTitle(availabilityType, price),
      start: startDate.toDate(),
      end: calendarEndDate.toDate(), // ✅ +1 día para react-big-calendar
      price: availabilityType === AVAILABILITY_TYPES.BLOCKED ? 0 : price,
      type: availabilityType,
      // ✅ AÑADIR: originalData con las fechas reales (sin +1 día)
      originalData: {
        start: startDate.format('YYYY-MM-DD'),
        end: endDate.format('YYYY-MM-DD'),
        amount: availabilityType === AVAILABILITY_TYPES.BLOCKED ? 0 : price,
        typeHousingCalendar: this.mapToServerType(availabilityType)
      },
      resource: {
        backgroundColor: COLORS[availabilityType],
        textColor: '#ffffff'
      }
    };

    console.log('💾 Guardando nuevo evento:', {
      userSelection: { 
        start: startDate.format('YYYY-MM-DD'), 
        end: endDate.format('YYYY-MM-DD') 
      },
      calendarEvent: { 
        start: startDate.format('YYYY-MM-DD'), 
        end: calendarEndDate.format('YYYY-MM-DD') 
      },
      display: `Del ${startDate.format('DD/MM/YYYY')} al ${endDate.format('DD/MM/YYYY')}`
    }); // ✅ DEBUG

    // Verificar solapamiento
    if (this.checkOverlap(newEvent)) {
      this.setState({ error: "Las fechas seleccionadas se solapan con eventos existentes" });
      return;
    }

    try {
      // Agregar al state local
      this.setState(prevState => ({
        calendarEvents: [...prevState.calendarEvents, newEvent],
        showSidebar: false,
        selectedRange: null,
        error: null
      }));

      // Guardar en servidor
      await this.saveToServer(newEvent);
      
    } catch (error) {
      this.setState({ error: "Error al guardar. Intente nuevamente." });
    }
  };

  // Generar título del evento
  generateEventTitle = (type, price) => {
    switch (type) {
      case AVAILABILITY_TYPES.BLOCKED: return 'Bloqueado';
      case AVAILABILITY_TYPES.HOT_SALE: return 'Hot Sale';
      case AVAILABILITY_TYPES.RESERVATION: return 'Reserva';
      default: return `$${price}`;
    }
  };

  // Verificar solapamiento
  checkOverlap = (newEvent) => {
    const newStart = moment(newEvent.start);
    const newEnd = moment(newEvent.end);

    return this.state.calendarEvents.some(event => {
      const eventStart = moment(event.start);
      const eventEnd = moment(event.end);
      
      return (newStart.isBefore(eventEnd) && newEnd.isAfter(eventStart));
    });
  };

  // ✅ NUEVA FUNCIÓN: Obtener eventos frescos del servidor
  getDatesFromServer = async () => {
    try {
      const response = await AxiosAuth.get(`${BASE_URL}/housing/public/13/${this.state.housingId}`);
      return response.data.calendar || [];
    } catch (error) {
      console.error('❌ Error al obtener eventos del servidor:', error);
      // Fallback a los eventos actuales del props si falla
      return this.props.bodyParameters.calendar || [];
    }
  };

  // ✅ MODIFICADO: Guardar en servidor enviando calendario completo
  saveToServer = async (event) => {
    try {
      // 🔄 PASO 1: Obtener eventos frescos del servidor
      const existingEvents = await this.getDatesFromServer();
      
      console.log('📅 Eventos existentes del servidor:', existingEvents.length);
      
      // 🔄 PASO 2: Convertir el nuevo evento al formato del servidor
      const newEventForServer = {
        start: moment(event.start).format('YYYY-MM-DD'),
        end: moment(event.end).format('YYYY-MM-DD'),
        // ✅ CORRECTO: amount como string según el formato esperado
        amount: event.price ? event.price.toString() : "",
        // ✅ AÑADIR: campos requeridos isAvailable e isBlocked
        isAvailable: event.type === AVAILABILITY_TYPES.AVAILABLE || event.type === AVAILABILITY_TYPES.HOT_SALE,
        isBlocked: event.type === AVAILABILITY_TYPES.BLOCKED,
        typeHousingCalendar: this.mapToServerType(event.type),
        // ✅ OPCIONAL: mantener compatibilidad con campos anteriores
        hotSale: event.type === AVAILABILITY_TYPES.HOT_SALE
      };
      
      // 🔄 PASO 3: Combinar eventos existentes con el nuevo evento
      const allEvents = [...existingEvents, newEventForServer];
      
      console.log('💾 Enviando calendario completo con', allEvents.length, 'eventos');
      
      // 🔄 PASO 4: Enviar calendario completo al servidor
      const body = {
        // ✅ CORRECTO: id como número entero (no string)
        id: parseInt(this.state.housingId, 10),
        calendar: allEvents
      };

      const url = this.props.steps[15]?.endopoit || `${BASE_URL}/housing/calendar`;

      await AxiosAuth.post(url, body);
      
      // 🔄 PASO 5: Actualizar el estado global con todos los eventos
      this.props.calendarStep({ calendar: allEvents });
      
      console.log('✅ Calendario guardado exitosamente');
      
    } catch (error) {
      console.error('❌ Error al guardar calendario:', error);
      throw error; // Re-lanzar el error para que se maneje en handleSave
    }
  };

  // Mapear tipo al formato del servidor
  mapToServerType = (type) => {
    switch (type) {
      case AVAILABILITY_TYPES.BLOCKED: return 'block';
      case AVAILABILITY_TYPES.HOT_SALE: return 'hot_sale'; 
      case AVAILABILITY_TYPES.RESERVATION: return 'Hold';
      case AVAILABILITY_TYPES.AVAILABLE:
      default: return 'available';
    }
  };

  // Eliminar evento
  handleDeleteEvent = async () => {
    const { eventToDelete } = this.state;
    if (!eventToDelete) return;

    try {
      // Eliminar del servidor si es necesario
      if (eventToDelete.originalData) {
        const url = `${BASE_URL}/housing/delete-dates-calendar`;
        const body = {
          calendar: {
            housingId: parseInt(this.state.housingId, 10),
            calendar: [{
              // ✅ CORREGIDO: Usar fechas originales del servidor
              startDate: eventToDelete.originalData.start,
              endDate: eventToDelete.originalData.end
            }]
          }
        };
        
        console.log('🗑️ Eliminando evento:', body); // ✅ DEBUG
        await AxiosAuth.delete(url, { data: body });
      }

      // Eliminar del state local
      this.setState(prevState => ({
        calendarEvents: prevState.calendarEvents.filter(event => event.id !== eventToDelete.id),
        showDeleteModal: false,
        eventToDelete: null
      }));

    } catch (error) {
      console.error('❌ Error al eliminar evento:', error); // ✅ DEBUG
      this.setState({ error: "Error al eliminar evento" });
    }
  };

  // ✅ MOVER: Función helper para formatear fechas sin problemas de timezone
  formatDateForInput = (date) => {
    if (!date) return '';
    
    // Crear una nueva fecha asegurándose de usar la timezone local
    const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
    return localDate.toISOString().split('T')[0];
  };

  // Componente personalizado para mostrar eventos con precio
  EventComponent = ({ event }) => (
    <div className="calendar-event">
      <div className="event-title">{event.title}</div>
      {event.price > 0 && (
        <div className="event-price">${event.price}</div>
      )}
    </div>
  );

  // ✅ SIMPLIFICAR el componente DayComponent para evitar conflictos:
  DayComponent = ({ children, value, ...props }) => {
    // Solo renderizar el contenido por defecto del calendario
    // No interferir con la renderización normal
    return (
      <div className="rbc-day-bg" {...props}>
        {children}
      </div>
    );
  };

  // Renderizar sidebar
  renderSidebar = () => {
    if (!this.state.showSidebar) return null;

    const { selectedRange, availabilityType, price, userRole } = this.state;

    return (
      <div className="calendar-sidebar">
        <div className="sidebar-content">
          <h3>Configurar fechas</h3>
          
          {selectedRange && (
            <div className="date-inputs">
              <div className="date-inputs__group">
                <label htmlFor="start-date">Desde:</label>
                <input
                  id="start-date"
                  type="date"
                  // ✅ CORREGIDO: Formatear fecha sin problemas de timezone
                  value={this.formatDateForInput(selectedRange.start)}
                  onChange={(e) => this.handleDateChange('start', e.target.value)}
                />
              </div>
              <div className="date-inputs__group">
                <label htmlFor="end-date">Hasta:</label>
                <input
                  id="end-date"
                  type="date"
                  // ✅ CORREGIDO: Formatear fecha sin problemas de timezone
                  value={this.formatDateForInput(selectedRange.end)}
                  onChange={(e) => this.handleDateChange('end', e.target.value)}
                />
              </div>
            </div>
          )}

          <div className="form-group">
            <label>Tipo de disponibilidad</label>
            <div className="availability-options">
              <label className="radio-option">
                <input
                  type="radio"
                  name="availability"
                  value={AVAILABILITY_TYPES.BLOCKED}
                  checked={availabilityType === AVAILABILITY_TYPES.BLOCKED}
                  onChange={(e) => this.setState({ availabilityType: e.target.value })}
                />
                <span>Bloqueado</span>
              </label>

              <label className="radio-option">
                <input
                  type="radio"
                  name="availability"
                  value={AVAILABILITY_TYPES.AVAILABLE}
                  checked={availabilityType === AVAILABILITY_TYPES.AVAILABLE}
                  onChange={(e) => this.setState({ availabilityType: e.target.value })}
                />
                <span>Disponible</span>
              </label>

              {userRole.role === 'admin' && (
                <>
                  <label className="radio-option">
                    <input
                      type="radio"
                      name="availability"
                      value={AVAILABILITY_TYPES.HOT_SALE}
                      checked={availabilityType === AVAILABILITY_TYPES.HOT_SALE}
                      onChange={(e) => this.setState({ availabilityType: e.target.value })}
                    />
                    <span>Hot Sale</span>
                  </label>

                  <label className="radio-option">
                    <input
                      type="radio"
                      name="availability"
                      value={AVAILABILITY_TYPES.RESERVATION}
                      checked={availabilityType === AVAILABILITY_TYPES.RESERVATION}
                      onChange={(e) => this.setState({ availabilityType: e.target.value })}
                    />
                    <span>Registrar reserva</span>
                  </label>
                </>
              )}
            </div>
          </div>

          {availabilityType !== AVAILABILITY_TYPES.BLOCKED && (
            <div className="form-group">
              <label htmlFor="price">Precio por noche</label>
              <input
                id="price"
                type="number"
                value={price}
                onChange={(e) => this.setState({ price: parseInt(e.target.value) || 0 })}
                placeholder="Precio"
              />
            </div>
          )}

          {this.state.error && (
            <ErrorAlert message={this.state.error} />
          )}

          <div className="sidebar-actions">
            <button
              className="btn btn-secondary"
              onClick={() => this.setState({ showSidebar: false, selectedRange: null, error: null })}
            >
              Cancelar
            </button>
            <button
              className="btn btn-primary"
              onClick={this.handleSave}
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    );
  };

  currentLenguaje = (json) => {
    return json[this.state.lenguaje];
  };

  render() {
    const { calendarEvents, showDeleteModal, eventToDelete } = this.state;

    return (
      <React.Fragment>
        <div className="new-calendar-container">
          {!this.state.modeEdit && (
            <div className="progress-bar">
              <ProgressBar
                title={this.currentLenguaje(TradCalendar).calendario}
                stepAt={"Paso 3: Toques finales"}
              />
            </div>
          )}

          {/* ✅ Botón volver arriba del título */}
          <div className="back-button-container">
            <button
              className="back-link"
              onClick={() => window.location.href = "/profile/housing"}
            >
              ← {this.currentLenguaje(TradCalendar).volver}
            </button>
          </div>

          <div className="calendar-header">
            <h1>{this.currentLenguaje(TradCalendar).calendario}</h1>
            <p>{this.currentLenguaje(TradCalendar).description}</p>
          </div>

          <div className="calendar-layout">
            <div className="calendar-main">
              <Calendar
                localizer={localizer}
                events={calendarEvents}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 600 }}
                onSelectSlot={this.handleSelectSlot}
                onSelectEvent={this.handleSelectEvent}
                selectable={true}
                views={['month']}
                defaultView='month'
                components={{
                  event: this.EventComponent,
                  // ✅ REMOVIDO: dateCellWrapper que estaba causando problemas de renderización
                  // dateCellWrapper: this.DayComponent
                }}
                eventPropGetter={(event) => ({
                  style: {
                    backgroundColor: event.resource.backgroundColor,
                    color: event.resource.textColor,
                    border: 'none',
                    borderRadius: '4px'
                  }
                })}
                messages={{
                  next: "Siguiente",
                  previous: "Anterior", 
                  today: "Hoy",
                  month: "Mes",
                  week: "Semana",
                  day: "Día"
                }}
              />

              <div className="calendar-actions">
                <ButtonPrimary
                  title="Precios automáticos"
                  onClick={() => window.location.href = `/pricing/${this.state.housingId}`}
                />
              </div>

              {this.state.modeEdit && (
                <CalendarSincronize housingId={this.state.housingId} />
              )}
            </div>

            {this.renderSidebar()}
          </div>

          {/* ✅ AÑADIDO: Botones de navegación Anterior/Siguiente */}
          <div className="calendar-navigation-buttons" style={{ marginTop: '2rem', paddingBottom: '2rem', maxWidth: '1200px', margin: '2rem auto 0 auto', padding: '0 20px' }}>
            {this.state.modeEdit ? <ButtonEdit /> : <Buttons />}
          </div>
        </div>

        {/* ✅ CORREGIDO: Modal personalizado de confirmación de eliminación */}
        {showDeleteModal && eventToDelete && (
          <div className="confirm-modal-overlay" onClick={() => this.setState({ showDeleteModal: false, eventToDelete: null })}>
            <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
              <h3>Confirmar eliminación</h3>
              <p>¿Está seguro que desea eliminar esta configuración del calendario?</p>
              
              <div className="delete-info">
                <div className="date-range">
                  <div className="date-item">
                    <span className="label">Desde</span>
                    {/* ✅ CORREGIDO: Usar datos originales si están disponibles */}
                    <span className="date">
                      {eventToDelete.originalData 
                        ? moment(eventToDelete.originalData.start).format('DD/MM/YYYY')
                        : moment(eventToDelete.start).format('DD/MM/YYYY')
                      }
                    </span>
                  </div>
                  <span className="separator">→</span>
                  <div className="date-item">
                    <span className="label">Hasta</span>
                    <span className="date">
                      {eventToDelete.originalData 
                        ? moment(eventToDelete.originalData.end).format('DD/MM/YYYY')  // ✅ Sin .subtract()
                        : moment(eventToDelete.end).subtract(1, 'day').format('DD/MM/YYYY')
                      }
                    </span>
                  </div>
                </div>
              </div>

              <div className="modal-actions">
                <button
                  className="btn btn-cancel"
                  onClick={() => this.setState({ showDeleteModal: false, eventToDelete: null })}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-delete"
                  onClick={this.handleDeleteEvent}
                >
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (reducers) => {
  return reducers.aloharFormReducer;
};

export default withRouter(
  connect(mapStateToProps, aloharFormActions)(NewCalendar)
);